import {ChangeDetectorRef, Component} from '@angular/core';
import { NavController, NavParams, AlertController, App, Config } from 'ionic-angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ViewController } from "ionic-angular";

import { ApiService } from "../../services/api.service";
import { DataService } from "../../services/data.service";
import { InAppBrowser } from "@ionic-native/in-app-browser";

import { TabsPage } from "../tabs/tabs";
import { XpTabsPage } from "../xp-tabs/xp-tabs";
import { XpWorkorderService } from "../../services/xp-workorder.service";
import { ActivityLogService } from "../../services/activity-log.service";
import { TranslateService } from "@ngx-translate/core";

declare var LOGIN_USERNAME;
declare var LOGIN_PASSWORD;

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  showLogin = false;
  showPassword = false;
  submitAttempt = false;
  busy = false;
  searchPerformed = false;
  loginForm: FormGroup;
  language = 'nl';
  showLanguageSelect = true;
  selectedCountry = '';

  constructor(
    public app: App,
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public changeDetector: ChangeDetectorRef,
    public formBuilder: FormBuilder,
    public alertCtrl: AlertController,
    public apiService: ApiService,
    public dataService: DataService,
    public iab: InAppBrowser,
    public translate: TranslateService,
    public config: Config,
    public xpWorkorderService: XpWorkorderService,
    public activityLogService: ActivityLogService
  ) {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.compose([Validators.required])],
      password: ['', Validators.compose([Validators.required])]
    });
    this.language = this.translate.currentLang;
  }

  login(){
    if(this.loginForm.valid){
      this.busy = true;
      let username = this.loginForm.value.username;
      let password = this.loginForm.value.password;
      this.apiService.login(username, password).then(() => {
        this.dataService.updateUnitBrands().then(() => {
          this.busy = false;
          this.changeDetector.detectChanges();
          this.goToMain();
        }).catch(() => {
          this.busy = false;
          this.changeDetector.detectChanges();
          this.goToMain();

        });
      }).catch((error) => {
        this.busy = false;
        this.changeDetector.detectChanges();
        console.log('login error');
        let msg =  'De ingevoerde gegevens zijn incorrect.';
        if(error === -1) msg = 'Verbindingsfout (-1)';
        if(error === -2) msg = 'Verbindingsfout (-2)';
        if(error === -3) msg = 'U heeft geen actieve licentie waarmee u gebruik kunt maken van de app.';
        this.alertCtrl.create({
          title: 'Fout',
          message: msg,
          cssClass: 'alert-error',
          buttons: ['OK']
        }).present();
      });
    }
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
    // Prefill username and password
    if(typeof LOGIN_USERNAME != 'undefined' && typeof LOGIN_PASSWORD != 'undefined'){
      this.loginForm.patchValue({
        username: LOGIN_USERNAME,
        password: LOGIN_PASSWORD
      });
    }
    // Get language code from 'language' GET variable and select it
    let urlParams = new URLSearchParams(window.location.search);
    let lang = urlParams.get('language');
    if (lang) {
      this.language = lang;
      this.showLanguageSelect = false;
      this.selectedCountry = 'UY';
      this.changeLanguage();
    }
  }

  openPasswordReset(){
    this.iab.create('https://www.mijninstallatiepas.nl/portal/password/forgotten', '_system');
  }

  goToLogin(){
    this.showLogin = true;
  }

  goBack(){
    this.showLogin = false;
  }

  goToMain(){
    this.closeModal();
    this.app.getRootNavs()[0].setRoot(TabsPage);
  }

  goToXp(){
    this.alertCtrl.create({
      title: 'XPRNZ',
      message: this.translate.instant('Stappenplan bij de hand?'),
      buttons: [
        {
          text: this.translate.instant('Nee'),
          handler: () => {
            this.alertCtrl.create({
              title: this.translate.instant('Stappenplan downloaden'),
              message: this.translate.instant("Klik op 'Downloaden' om het stappenplan te downloaden."),
              buttons: [
                {
                  text: this.translate.instant('Annuleren'),
                  role: 'cancel'
                },
                {
                  text: this.translate.instant('Downloaden'),
                  handler: () => {
                    // Bericht weergeven, 2 seconden vertraging, daarna downloaden (FD#255).
                    let msg = this.translate.instant("Het stappenplan met naam 'Maintenanz-XPRNZ-NL' wordt nu gedownload.");
                    let alert = this.alertCtrl.create({
                      title: this.translate.instant('Downloaden'),
                      message: msg
                    });
                    alert.present();
                    setTimeout(() => {
                      if(alert){
                        alert.dismiss();
                      }
                      this.downloadXpPlan();
                    }, 2000);
                  }
                }
              ]
            }).present();
          }
        },
        {
          text: this.translate.instant('Ja'),
          handler: () => {
            if(this.selectedCountry){
              this.goToXpCountry(this.selectedCountry);
            } else {
              this.alertCtrl.create({
                title: this.translate.instant('Kies uw land'),
                cssClass: 'alert-not-bold',
                message: this.translate.instant('In welk land bevindt u zich?'),
                buttons: [
                  {
                    text: this.translate.instant('Nederland'),
                    handler: () => {
                      this.goToXpCountry('NL');
                    }
                  },
                  {
                    text: this.translate.instant('België'),
                    handler: () => {
                      this.goToXpCountry('BE');
                    }
                  },
                  {
                    text: this.translate.instant('Uruguay'),
                    handler: () => {
                      this.goToXpCountry('UY');
                    }
                  }
                ]
              }).present();
            }
          }
        }
      ]
    }).present();
  }

  downloadXpPlan(){
    if(this.language == 'es') {
      this.iab.create('https://www.mijninstallatiepas.nl/assets/xprnz/AIRPORT-PILOT-XPRNZ-UY.pdf', '_system');
    } else {
      this.iab.create('https://www.mijninstallatiepas.nl/assets/xprnz/AIRPORT-PILOT-XPRNZ-ENG.pdf', '_system');
    }
  }

  goToXpCountry(country){
    this.activityLogService.log('xprnz_start', { country: country });
    this.xpWorkorderService.setCountry(country);
    this.closeModal();
    this.app.getRootNavs()[0].setRoot(XpTabsPage);
  }

  toggleShowPassword(){
    this.showPassword = !this.showPassword;
  }

  changeLanguage(){
    this.translate.use(this.language).subscribe(() => {
      this.config.set('backButtonText', this.translate.instant('Terug'));
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts